import React from "react";
import {
  Grid,
  List, 
  ListItem, 
  ListItemText, 
  Typography,
  Box,
  Container
} from "@mui/material";


import Layout from "./../components/Layout/Layout";



const PrivacyPolicy = () => {
  return (
    <Layout>
      <Box sx={{ py: 5 }}>
       
        <Container maxWidth="lg">
          <Grid container spacing={4} justifyContent="center" alignItems="stretch">
          <Box sx={{ 
              padding: "20px", 
              textAlign: "justify", 
              maxWidth: "900px", 
              margin: "auto", 
              position: "relative" 
            }}>
          <div >
            
            <Typography variant="h4" gutterBottom  style={{ marginBottom: '20px' }}>
                Privacy Policy
            </Typography>
            <div style={{ marginBottom: '20px' }}>
                <Typography variant="h5" >Introduction</Typography>
                <Typography variant="body4" style={{ lineHeight: '1.6' }}>
                    Welcome to Finnkoda. Your privacy is important to us. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our application. Please read this policy carefully. If you do not agree with the terms of this privacy policy, please do not access the application.
                </Typography>
            </div>

            <Typography variant="h5"  style={{ marginBottom: '10px' }}>Information We Collect</Typography>
            <List>
                <ListItem>
                    <ListItemText>
                        <Typography variant="body4">Personal Information</Typography>
                        <List variant="body4">
                            <ListItem>
                                <ListItemText >Name</ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText >Date of birth</ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText >Identification numbers (e.g., Social Security Number, Passport Number) etc...</ListItemText>
                            </ListItem>
                        </List>
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemText>
                        <Typography variant="body4" >General Information</Typography>
                        <List variant="body4">
                            <ListItem>
                                <ListItemText >Telephone details</ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText >Internet details</ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText >Electricity details etc...</ListItemText>
                            </ListItem>
                        </List>
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemText>
                        <Typography variant="body4" >Contact Information</Typography>
                        <List variant="body4">
                            <ListItem>
                                <ListItemText >Financial Adviser details</ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText >Tax Consultant details</ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText >Insurance Consultant details etc...</ListItemText>
                            </ListItem>
                        </List>
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemText>
                        <Typography variant="body4" >Records Mangement</Typography>
                        <List variant="body4">
                            <ListItem>
                                <ListItemText >Key Location details</ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText >DigiLocker details</ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText >Mortgage details etc...</ListItemText>
                            </ListItem>
                        </List>
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemText>
                        <Typography variant="body4" >Mutual Fund Information</Typography>
                        <List variant="body4">
                            <ListItem>
                                <ListItemText >Folio Number details</ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText >Name of Fund details</ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText >Nominee details etc...</ListItemText>
                            </ListItem>
                        </List>
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemText>
                        <Typography variant="body4" >Trading Account Information</Typography>
                        <List variant="body4">
                            <ListItem>
                                <ListItemText >DP Id details</ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText >Customer Id details</ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText >Nominee details etc...</ListItemText>
                            </ListItem>
                        </List>
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemText>
                        <Typography variant="body4" >Stock Information</Typography>
                        <List variant="body4">
                            <ListItem>
                                <ListItemText >Stock details</ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText >CMP details</ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText >Brokerage details etc...</ListItemText>
                            </ListItem>
                        </List>
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemText>
                        <Typography variant="body4" >Bank Account Information</Typography>
                        <List variant="body4">
                            <ListItem>
                                <ListItemText >Bank account numbers details</ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText >Customer Id details etc...</ListItemText>
                            </ListItem>
                        </List>
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemText>
                        <Typography variant="body4" >FD (Fixed Deposit) and Post Office Information</Typography>
                        <List variant="body4">
                            <ListItem>
                                <ListItemText >FD details</ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText >Post office savings information details etc...</ListItemText>
                            </ListItem>
                        </List>
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemText>
                        <Typography variant="body4" >Card Information</Typography>
                        <List variant="body4">
                            <ListItem>
                                <ListItemText >Name of Bank details</ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText >Card details</ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText >Expiry Date details etc...</ListItemText>
                            </ListItem>
                        </List>
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemText>
                        <Typography variant="body4" >Life Insurance Information</Typography>
                        <List variant="body4">
                            <ListItem>
                                <ListItemText >Name of company details</ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText >Policy details</ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText >Nominee details etc...</ListItemText>
                            </ListItem>
                        </List>
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemText>
                        <Typography variant="body4" >Health Insurance Information</Typography>
                        <List variant="body4">
                            <ListItem>
                                <ListItemText >Name of company details</ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText >Policy details</ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText >Nominee details etc...</ListItemText>
                            </ListItem>
                        </List>
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemText>
                        <Typography variant="body4" >General Insurance Information</Typography>
                        <List variant="body4">
                            <ListItem>
                                <ListItemText >Name of company details</ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText >Policy details</ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText >Nominee details etc...</ListItemText>
                            </ListItem>
                        </List>
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemText>
                        <Typography variant="body4" >Loan Information</Typography>
                        <List variant="body4">
                            <ListItem>
                                <ListItemText >Bank/Financial Institution Name</ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText >Loan details</ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText >Installment details etc...</ListItemText>
                            </ListItem>
                        </List>
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemText>
                        <Typography variant="body4" >NPS (National Pension System) Information</Typography>
                        <List variant="body4">
                            <ListItem>
                                <ListItemText >Name of company details</ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText >Policy details</ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText >Nominee details etc...</ListItemText>
                            </ListItem>
                        </List>
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemText>
                        <Typography variant="body4" >Public Provident Fund (PPF) Information</Typography>
                        <List variant="body4">
                            <ListItem>
                                <ListItemText >Account details</ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText >Bank and Branch details</ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText >Nominee details etc...</ListItemText>
                            </ListItem>
                        </List>
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemText>
                        <Typography variant="body4" >Pension Fund Information</Typography>
                        <List variant="body4">
                            <ListItem>
                                <ListItemText >UAN details</ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText >EPF details</ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText >Nominee details etc...</ListItemText>
                            </ListItem>
                        </List>
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemText>
                        <Typography variant="body4" >Property Information</Typography>
                        <List variant="body4">
                            <ListItem>
                                <ListItemText >Property Holder details</ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText >Address details</ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText >Nominee details etc...</ListItemText>
                            </ListItem>
                        </List>
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemText>
                        <Typography variant="body4" >Vehicle Information</Typography>
                        <List variant="body4">
                            <ListItem>
                                <ListItemText >Name & Model details</ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText >Purchase details</ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText >Dealer details etc...</ListItemText>
                            </ListItem>
                        </List>
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemText>
                        <Typography variant="body4" >Bond Information</Typography>
                        <List variant="body4">
                            <ListItem>
                                <ListItemText >Bond details</ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText >Nominee details etc...</ListItemText>
                            </ListItem>
                        </List>
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemText>
                        <Typography variant="body4" >Gold Information</Typography>
                        <List variant="body4">
                            <ListItem>
                                <ListItemText >Gold details</ListItemText>
                            </ListItem>
                            <ListItem>
                                <ListItemText >Purchase details etc...</ListItemText>
                            </ListItem>
                        </List>
                    </ListItemText>
                </ListItem>
            </List>

            <Typography variant="h6"  style={{ marginBottom: '10px' }}>How We Use Your Information</Typography>
            <Typography variant="body4"  style={{ marginBottom: '20px' }}>
                We use the information we collect in the following ways:
            </Typography>
            <List style={{ marginBottom: '20px' }}>
                <ListItem >To provide and manage the services you request</ListItem>
                <ListItem >To manage your account and provide customer support</ListItem>
            </List>
            <Typography variant="h6"  style={{ marginBottom: '10px' }}>Sharing Your Information</Typography>
            <Typography variant="body4"  style={{ marginBottom: '20px' }}>
                We may share your information with:
            </Typography>
            <List style={{ marginBottom: '20px' }}>
                <ListItem >Third-party service providers who perform services on our behalf</ListItem>
                <ListItem >Financial institutions and partners involved in the processing of your transactions</ListItem>
                <ListItem >Regulatory and legal authorities as required by law</ListItem>
                <ListItem >In the event of a merger, acquisition, or sale of assets, your information may be transferred to the new owner</ListItem>
            </List>
            <Typography variant="h6"  style={{ marginBottom: '10px' }}>Data Security</Typography>
            <Typography variant="body4"  style={{ lineHeight: '1.6' }}>
                We implement a variety of security measures to maintain the safety of your personal information. Your information is stored on secured networks and is only accessible by a limited number of persons who have special access rights to such systems.
            </Typography>
            <Typography variant="h6"  style={{ marginTop: '10px' }}>Your Choices</Typography>
            <List>
                <ListItem >Access and update your personal information</ListItem>
                <ListItem >Opt-out of receiving marketing communications</ListItem>
                <ListItem >Request the deletion of your personal data, subject to legal constraints</ListItem>
            </List>
            <Typography variant="h6"  style={{ marginBottom: '10px' }}>Changes to This Privacy Policy</Typography>
            <Typography variant="body4"  style={{ lineHeight: '1.6' }}>
                We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated revision date. We encourage you to review this Privacy Policy periodically.
            </Typography>
        </div>
        </Box>
          </Grid>
        </Container>
      </Box>
    </Layout>
  );
};

export default PrivacyPolicy;
